"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _rcProgress = require("rc-progress");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _selectors = require("@certilogo/design-system/dist/shared/styles/themes/selectors");

var _polished = require("polished");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var LineStyle = (0, _styledComponents["default"])(_rcProgress.Line).attrs(function (props) {
  return {
    strokeColor: (0, _selectors.primaryColor)(props),
    trailColor: (0, _polished.transparentize)(0.9, (0, _selectors.primaryColor)(props))
  };
})(_templateObject());
var _default = LineStyle;
exports["default"] = _default;